import React from "react";
import PromotionCard from "../shared/promotionCard";
import PromotionIcon from "../constants/assests/image/promotionIcon.png";
import PromotionList from "../constants/assests/text_content/promotionList.json";
import PromotionHeader from '../shared/header'
import { FaArrowLeft } from "react-icons/fa6";

function PromotionPage() {
  return (
    <div className="flex flex-col min-h-[100vh] max-h-[100vh] w-screen overflow-x-hidden">
      <div className=" mx-4 flex flex-col">
        <div className="sticky top-0 z-10 bg-white overflow-x-hidden">
        <PromotionHeader icon={<FaArrowLeft />} name="Promotions" />
        </div>
        <div className="my-4 h-full overflow-auto flex-1">
          {PromotionList.map((item, index) => (
            <div className="px-5" key={index}>
              <PromotionCard
                header={item.header}
                description={item.description}
                src={PromotionIcon}
                footerText={item.footerText}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PromotionPage;
